import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import TechniciansListPage from '../containers/TechniciansListPage';

const TechniciansPage = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={match.url}>
        <TechniciansListPage />
      </Route>
    </Switch>
  );
};

export default TechniciansPage;
